import { Route, Routes } from 'react-router-dom';

import RouteAuth from '../../core/security/routeAuth';
import { Role } from '../Security/models/Authorization';

import { EconomyActivity } from './EconomyActivity/pages/economyActivity/economyActivity.lazy';

export const OperationsRouting = () => {
  return (
    <Routes>
      <Route
        path="economy-activity"
        element={
          <RouteAuth access={[Role.FormsAdmin]}>
            <EconomyActivity />
          </RouteAuth>
        }
      />
    </Routes>
  );
};
